module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAgCAYAAAASYli2AAABM0lEQVRIS+1WPYuEMBCdaCFrKyosuIo2FoL+f/AnCAqW4idYKLYRC80y2btl7w7d1e7AaQLmzUvmI74hYRgyWZbher0CroQQ2GOMMaCUQtu2fCVRFLEgCEAQhD08f7DLskAcx0AopexyucA0TdD3PeCJewwjUlUVJEmCcRyBLMvC8GOaptB13R6uJ1bTNPA8j1+GsK8rJUkCwzAcIlQUBXzf574n4ZnDD5vobJvH3+B8eh82zAN2ts1/aRvU1Hmed1X3GyyKItf0H5qyxoR6WxQF123Lst4OAk+RWiPM8xzKsuTbjuOAaZqbUbwlrOsasizjJK7r8pFly55CvwZC2ca5BfOk6/pmyFzoq6pit9vtUDF+O2E0BKcv27bBMAye+CPTFxauaRrAfHPC15OOEL763wGorU5NUMALWAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile.png
// module id = HXsc
// module chunks = 4